module.exports = __webpack_public_path__ + "img/banker-purple-page_1248.fce1798c.png";